export default "__VITE_ASSET__DRO2RGcg__"